// extracted by mini-css-extract-plugin
export default {"container":"SFagX0trBrxaTusG6hHD","showScore":"vyD8SftD_0bblcIFymrw"};